import { useState } from 'react';
import {loadConnectAndInitialize} from '@stripe/connect-js';
import {createAccountSession} from '../services/stripeService';
import {
  ConnectPayouts,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import i18n from '../i18n';

const PayoutLogPage: React.FC = () => {
  const [stripeConnectInstance] = useState(() => {
    const fetchClientSecret = async (): Promise<string> => {
      try {
        const response = await createAccountSession();
        return response.clientSecret;
      } catch (error) {
        console.error('An error occurred: ', error);
        return '';
      }
    }

    return loadConnectAndInitialize({
      publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret: fetchClientSecret,
      locale: i18n.language === 'zh' ? 'zh-Hant-HK' : 'en',
    })
  });

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectPayouts />
    </ConnectComponentsProvider>
  );
};

export default PayoutLogPage;
